<template>
  <div>
    <template>
      <h4
        class="not-margin"
        :style="{
          fontWeight: 'bold',
          color: '#195BFF',
          fontSize: '18px',
          marginTop: '10px',
        }"
      >
        <i
          class="fal fa-info-circle"
          :style="{ width: '30px', fontSize: '18px' }"
        ></i>
        ປ່ຽນສາຂາຕີກັບ
      </h4>
    </template>

    <div class="columns" :style="{ marginTop: '10px' }">
      <div class="field column">
        <div class="control">
          <label class="label">{{ $t('ຂໍ້ມູນOrderDetail.ສາຂາປາຍທາງ') }}:</label>
          <model-list-select
            :list="branches"
            v-model="branch_id"
            :placeholder="$t('ຂໍ້ມູນOrderDetail.ເລືອກສາຂາປາຍທາງ')"
            option-text="name"
            option-value="id"
            selectedItem="name"
          >
          </model-list-select>
        </div>
      </div>
    </div>

    <div class="modal-footer">
      <button
        type="button"
        class="button is-success"
        @click="handleSubmit"
        :disabled="isLoading || !branch_id"
      >
        <i v-if="isLoading" class="fa fa-spinner fa-spin"></i>
        ປ່ຽນປາຍທາງຕີກັບ
      </button>
      <button
        type="button"
        class="button btn-clear"
        @click="$emit('close')"
      >
        ຍົກເລີກ
      </button>
    </div>
  </div>
</template>

<script>
import {ModelListSelect} from 'vue-search-select';

export default {
  name: 'ChangeRejectBranch',
  
  components: {
    ModelListSelect
  },
  
  props: {
    shipment_number: {
      type: String,
      required: true
    }
  },
  
  data() {
    return {
      branch_id: null,
      branches: [],
      isLoading: false,
      server_errors: {}
    };
  },
  
  methods: {
    fetchBranches() {
      this.$http.get('v1/listing/branches').then(res => {
        this.branches = res.data;
      }).catch(error => {
        console.error('Error fetching branches:', error);
      });
    },
    
    handleSubmit() {
      if (!this.branch_id) {
        this.$vs.notification({
          color: 'danger',
          title: 'ຂໍ້ຜິດພາດ',
          text: 'ກະລຸນາເລືອກສາຂາ'
        });
        return;
      }
      
      this.isLoading = true;
      
      const payload = {
        shipment_number: this.shipment_number,
        branch_id: this.branch_id
      };
      
      this.$axios.post('change-reject-branch', payload)
        .then(() => {
          this.$vs.notification({
            color: 'success',
            title: 'ສຳເລັດ',
            text: 'ປ່ຽນສາຂາຕີກັບສຳເລັດ'
          });
          this.$emit('success');
          this.$emit('close');
        })
        .catch(error => {
          this.isLoading = false;
          
          if (error.response && error.response.data) {
            if (error.response.data.errors) {
              this.server_errors = error.response.data.errors;
            }
            
            this.$vs.notification({
              color: 'danger',
              title: 'ຂໍ້ຜິດພາດ',
              text: error.response.data.message || 'ເກີດຂໍ້ຜິດພາດ'
            });
          }
        })
        .finally(() => {
          this.isLoading = false;
        });
    }
  },
  
  created() {
    this.fetchBranches();
  }
};
</script>

<style scoped>
.modal-footer {
  display: flex;
  justify-content: flex-end;
  gap: 10px;
  margin-top: 20px;
  padding-top: 20px;
  border-top: 1px solid #e0e0e0;
}

.btn-clear {
  background: #dc3545;
  color: white;
}

.btn-clear:hover {
  background: #c82333;
  color: white;
}
</style>